import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap";

function useFonts() {
  useEffect(() => {
    if (document.querySelector('link[href*="Instrument+Serif"]')) return;
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = FONTS_URL;
    document.head.appendChild(l);
  }, []);
}

const T = {
  g700: "#155c36", g600: "#1b7a47", g500: "#1e9254", g400: "#28b566",
  g200: "#a7d9bc", g100: "#d6f0e3", g50: "#eef8f3",
  n900: "#0f1117", n800: "#1c2130", n700: "#2d3549", n600: "#4a5268",
  n400: "#8a93a8", n300: "#b0b8cc", n200: "#d1d5e0", n150: "#e4e7ef",
  n100: "#eef0f5", n50: "#f7f8fa", white: "#ffffff",
  amber: "#d97706", amberBg: "#fffbeb", amberBorder: "#fde68a", amberText: "#92400e",
  blue: "#2563eb", blueBg: "#eff6ff", blueBorder: "#bfdbfe",
  serif: "'Instrument Serif', Georgia, serif",
  sans:  "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
};

const Icon = ({ name, size = 20, color = "currentColor", strokeWidth = 1.6 }) => {
  const paths = {
    ArrowLeft:     <><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></>,
    ArrowRight:    <><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></>,
    ChevronRight:  <><path d="m9 18 6-6-6-6"/></>,
    Search:        <><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></>,
    MapPin:        <><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></>,
    Star:          <><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></>,
    BadgeCheck:    <><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 12 2 2 4-4"/></>,
    Calendar:      <><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></>,
    Clock:         <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
    Wallet:        <><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"/><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/><path d="M18 12a2 2 0 0 0 0 4h4v-4Z"/></>,
    ShieldCheck:   <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></>,
    Tv:            <><rect width="20" height="15" x="2" y="3" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></>,
    Laptop:        <><path d="M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9"/><path d="M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-.18a1 1 0 0 0-.6-.92L20 18H4l-1.4.9a1 1 0 0 0-.6.92Z"/></>,
    Smartphone:    <><rect width="14" height="20" x="5" y="2" rx="2"/><path d="M12 18h.01"/></>,
    Fan:           <><path d="M12.785 14.36A4 4 0 0 1 12 22a1.8 1.8 0 0 1-1.8-1.8c0-1.5.9-2.4 1.8-3.6 1-1.5 2-2.6 2-4.6 0-1.3-1.1-2-2-2"/><path d="M12 12a4 4 0 0 1-4-7.785A4 4 0 0 1 16.97 7.4c-1.5 1-2.6 2-4.6 2-1.3 0-2-1.1-2-2"/><path d="M10.2 13.2A4 4 0 0 1 2 12a1.8 1.8 0 0 1 1.8-1.8c1.5 0 2.4.9 3.6 1.8 1.5 1 2.6 2 4.6 2 1.3 0 2-1.1 2-2"/><circle cx="12" cy="12" r="1"/></>,
    AlertTriangle: <><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3z"/><path d="M12 9v4M12 17h.01"/></>,
    Speaker:       <><rect width="16" height="20" x="4" y="2" rx="2"/><circle cx="12" cy="14" r="4"/><line x1="12" y1="6" x2="12.01" y2="6"/></>,
    User:          <><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></>,
    Truck:         <><path d="M5 17H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v3"/><rect width="7" height="7" x="14" y="10" rx="1"/><circle cx="7.5" cy="17.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></>,
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      {paths[name]}
    </svg>
  );
};

/* ─────────────────────────────────────────
   DATA
───────────────────────────────────────── */

const SUBSERVICES = [
  { icon: "Tv",         label: "TV repair",                 range: "KES 1,500 – 7,000",  note: "per repair" },
  { icon: "Fan",        label: "Fridge & appliance repair",  range: "KES 1,500 – 8,000",  note: "per repair" },
  { icon: "Laptop",     label: "Laptop & computer repair",   range: "KES 1,000 – 6,000",  note: "per repair" },
  { icon: "Smartphone", label: "Phone screen & repair",      range: "KES 1,500 – 9,000",  note: "per repair" },
  { icon: "Speaker",    label: "Sound systems & home theatre", range: "KES 1,000 – 5,000", note: "per repair" },
  { icon: "Truck",      label: "Diagnosis & collection",      range: "KES 500 – 1,500",   note: "if pickup needed" },
];

const HOW_IT_WORKS = [
  { num: "01", icon: "Search",   title: "Describe the fault",        desc: "Tell us what the device is, what's wrong, and whether you need a home visit or drop-off." },
  { num: "02", icon: "User",     title: "Compare verified technicians", desc: "See ratings, reviews, pricing, and real availability before you choose who handles your device." },
  { num: "03", icon: "Calendar", title: "Book a visit or drop-off",  desc: "Most repairs are diagnosed on the spot, with a clear quote before any work begins." },
  { num: "04", icon: "Wallet",   title: "Pay once it's working",     desc: "Funds are held securely and released to the technician only after you confirm the repair." },
];

const WHY_POINTS = [
  { icon: "BadgeCheck",  title: "Every technician is verified",    desc: "ID-checked and background-reviewed before they ever appear in search results. No exceptions." },
  { icon: "Star",        title: "Reviews tied to real bookings",    desc: "Every rating comes from a completed, paid booking. No anonymous or fake reviews ever make it onto a profile." },
  { icon: "ShieldCheck", title: "Covered by the Jirani Guarantee",  desc: "If a repair fails shortly after, our Trust and Safety team reviews it, including refunds where warranted." },
  { icon: "Wallet",      title: "Pay only when it's working",       desc: "Funds are held securely and only released to the technician after you confirm the device works as expected." },
];

const FAQS = [
  {
    q: "How much does TV or electronics repair cost in Kenya through JiraniApp?",
    a: "Most common repairs — a TV power board, a fridge compressor issue, a laptop screen or keyboard, a cracked phone screen — range from KES 1,000 to 9,000 depending on the device, the part needed, and whether it is an established or premium brand. Technicians on JiraniApp typically diagnose the fault first and give you a clear quote before starting any repair work.",
  },
  {
    q: "Do I need to bring my device in, or can a technician come to me?",
    a: "Both options are available depending on the device and the technician. Larger appliances like fridges and TVs are usually repaired at home, since transporting them is impractical. Smaller items like phones and laptops can often be repaired on a home visit or dropped off with the technician, whichever you and the Pro agree works best for the specific job.",
  },
  {
    q: "What if the technician cannot fix the device, or it needs a part that takes time to source?",
    a: "Most technicians diagnose first and tell you honestly if a repair is not viable or cost-effective compared to replacement. If a specific part needs to be sourced, the technician will tell you the expected wait time and whether a deposit is needed to order it. You are never charged for diagnosis alone unless this was agreed upfront and clearly stated on the Pro's profile.",
  },
  {
    q: "Is there a warranty on the repair if something goes wrong afterwards?",
    a: "Many technicians on JiraniApp offer a short informal warranty period on parts and labour, often two to four weeks, though this varies by Pro and is usually stated on their profile or in the booking conversation. If the same fault reoccurs within that window, message the technician directly first. If it cannot be resolved, you can open a dispute through Help and Support within 48 hours of the original booking.",
  },
  {
    q: "Can I get genuine or original parts used in my repair?",
    a: "This depends on the device, the part's availability in Kenya, and your budget. Many technicians offer a choice between original and compatible aftermarket parts, with original parts costing more. Ask the technician directly before the repair begins which option they are using and why, especially for phone screens and laptop batteries where the difference in longevity can be significant.",
  },
  {
    q: "What should I do before the technician arrives or I drop off my device?",
    a: "Back up any important data from phones, laptops, or computers if possible before handing the device over, since some repairs carry a small risk of data loss. Note down the specific fault and when it started, as this helps with diagnosis. If the device is under any existing manufacturer warranty, mention this, as it may affect the best repair option.",
  },
];

const TESTIMONIALS = [
  { name: "Esther M.", area: "Westlands, Nairobi",  text: "My fridge stopped cooling on a Friday evening. The technician came the next morning, diagnosed a faulty compressor relay, and had it running again within the hour.", rating: 5 },
  { name: "Yusuf A.",  area: "Mtwapa, Mombasa",      text: "Cracked my phone screen and was dreading the cost. Got a fair quote, genuine part option explained clearly, and it was fixed same day.", rating: 5 },
  { name: "Lucy N.",   area: "Kasarani, Nairobi",    text: "My laptop would not boot and I assumed I had lost everything. The technician recovered all my files before replacing the faulty drive.", rating: 5 },
];

/* ─────────────────────────────────────────
   COMPONENTS
───────────────────────────────────────── */

function SubServiceCard({ icon, label, range, note }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: "20px 18px", borderRadius: 14,
        border: `1.5px solid ${hovered ? T.g200 : T.n150}`,
        background: hovered ? T.g50 : T.white,
        transition: "all .18s", cursor: "default",
      }}>
      <div style={{
        width: 38, height: 38, borderRadius: 10,
        background: hovered ? T.g100 : T.n50,
        border: `1px solid ${hovered ? T.g200 : T.n150}`,
        display: "flex", alignItems: "center", justifyContent: "center",
        marginBottom: 14, transition: "all .18s",
      }}>
        <Icon name={icon} size={17} color={hovered ? T.g600 : T.n400} strokeWidth={1.7} />
      </div>
      <div style={{ fontSize: 14, fontWeight: 600, color: T.n800, marginBottom: 7 }}>{label}</div>
      <div style={{ fontFamily: T.serif, fontSize: 19, fontWeight: 400, color: hovered ? T.g700 : T.n900, letterSpacing: "-0.02em", lineHeight: 1.2 }}>{range}</div>
      <div style={{ fontSize: 11, color: T.n400, marginTop: 3 }}>{note}</div>
    </div>
  );
}

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderBottom: `1px solid ${T.n100}` }}>
      <button onClick={() => setOpen(o => !o)} style={{
        width: "100%", textAlign: "left", background: "none", border: "none",
        padding: "22px 0", display: "flex", justifyContent: "space-between",
        alignItems: "center", cursor: "pointer", gap: 20, fontFamily: T.sans,
      }}>
        <span style={{ fontSize: 15, fontWeight: 400, color: T.n800, lineHeight: 1.5, letterSpacing: "-0.01em" }}>{q}</span>
        <span style={{
          width: 28, height: 28, borderRadius: "50%", flexShrink: 0,
          border: `1px solid ${open ? T.g500 : T.n200}`,
          background: open ? T.g500 : "transparent",
          color: open ? T.white : T.n400,
          display: "flex", alignItems: "center", justifyContent: "center",
          transition: "all .22s cubic-bezier(.4,0,.2,1)",
          transform: open ? "rotate(45deg)" : "none",
          fontSize: 18, fontWeight: 300, lineHeight: 1,
        }}>+</span>
      </button>
      <div style={{ overflow: "hidden", maxHeight: open ? 400 : 0, transition: "max-height .32s cubic-bezier(.4,0,.2,1)" }}>
        <p style={{ margin: "0 0 22px", fontSize: 15, color: T.n600, lineHeight: 1.75, paddingRight: 48, fontFamily: T.sans }}>{a}</p>
      </div>
    </div>
  );
}

function TestimonialCard({ name, area, text, rating }) {
  const initials = name.split(" ").map(w => w[0]).slice(0, 2).join("");
  return (
    <div style={{ padding: "22px", borderRadius: 16, border: `1px solid ${T.n150}`, background: T.white, display: "flex", flexDirection: "column", gap: 14 }}>
      <div style={{ display: "flex", gap: 2 }}>
        {Array.from({ length: 5 }).map((_, i) => (
          <Icon key={i} name="Star" size={13} color={i < rating ? T.amber : T.n150} strokeWidth={0} />
        ))}
      </div>
      <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.75, margin: 0 }}>"{text}"</p>
      <div style={{ display: "flex", alignItems: "center", gap: 10, paddingTop: 6, borderTop: `1px solid ${T.n100}` }}>
        <div style={{ width: 34, height: 34, borderRadius: "50%", background: T.g50, border: `1.5px solid ${T.g100}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 600, color: T.g700, fontFamily: T.sans }}>{initials}</div>
        <div>
          <div style={{ fontSize: 13, fontWeight: 600, color: T.n900 }}>{name}</div>
          <div style={{ fontSize: 11, color: T.n400 }}>{area}</div>
        </div>
      </div>
    </div>
  );
}

/* ══ MAIN PAGE ══ */
export default function ElectronicsRepairCategoryPage() {
  useFonts();
  const navigate = useNavigate();
  const [location, setLocation] = useState("");
  const [searchFocused, setSearchFocused] = useState(false);

  const goToSearch = () => {
    const params = location.trim() ? `?category=electronics-repair&location=${encodeURIComponent(location.trim())}` : "?category=electronics-repair";
    navigate(`/search${params}`);
  };

  return (
    <div style={{ fontFamily: T.sans, background: T.white, minHeight: "100vh", color: T.n900, paddingBottom: 60 }}>
      <style>{`
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { display: none; }
      `}</style>

      {/* ── Nav ── */}
      <div style={{ padding: "16px 24px", borderBottom: `1px solid ${T.n100}`, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <button onClick={() => navigate(-1)} style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: "none", border: "none", cursor: "pointer",
          color: T.n400, fontSize: 13, fontFamily: T.sans, padding: 0,
        }}
          onMouseEnter={e => e.currentTarget.style.color = T.n800}
          onMouseLeave={e => e.currentTarget.style.color = T.n400}>
          <Icon name="ArrowLeft" size={14} strokeWidth={2} />
          Back
        </button>
        <button onClick={() => navigate("/pro-onboarding")} style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: "none", border: `1px solid ${T.n200}`, cursor: "pointer",
          color: T.n600, fontSize: 13, fontFamily: T.sans,
          padding: "8px 16px", borderRadius: 8, fontWeight: 500,
        }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = T.n400; e.currentTarget.style.color = T.n900; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = T.n200; e.currentTarget.style.color = T.n600; }}>
          Repair electronics? Join as a Pro
        </button>
      </div>

      {/* ══ HERO ══ */}
      <div style={{ padding: "clamp(52px,7vw,88px) 20px clamp(40px,5vw,56px)", borderBottom: `1px solid ${T.n100}` }}>
        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, color: T.g600, fontSize: 12, fontWeight: 600, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 22 }}>
            <Icon name="Tv" size={13} color={T.g500} strokeWidth={2.2} />
            TV &amp; Electronics Repair
          </div>
          <h1 style={{
            fontFamily: T.serif, fontSize: "clamp(38px,7vw,64px)", fontWeight: 400,
            margin: "0 0 18px", lineHeight: 1.07, color: T.n900, letterSpacing: "-0.03em", maxWidth: 600,
          }}>
            Broken device,<br/>
            <em style={{ fontStyle: "italic", color: T.g600 }}>fixed by someone who knows it</em>
          </h1>
          <p style={{ fontSize: "clamp(15px,2vw,17px)", color: T.n600, lineHeight: 1.75, margin: "0 0 32px", maxWidth: 520 }}>
            Book verified, reviewed technicians across Kenya for TVs, fridges, laptops, phones, and home
            appliances. Get an honest diagnosis and a clear quote before any repair begins.
          </p>

          {/* Search bar */}
          <div style={{
            display: "flex", gap: 8, padding: 8, borderRadius: 14,
            background: T.n50, border: `1.5px solid ${searchFocused ? T.g400 : T.n150}`,
            boxShadow: searchFocused ? `0 0 0 4px ${T.g100}` : "0 1px 4px rgba(0,0,0,.04)",
            transition: "all .18s", flexWrap: "wrap",
          }}>
            <div style={{ flex: 1, minWidth: 180, display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", background: T.white, borderRadius: 10 }}>
              <Icon name="MapPin" size={16} color={T.n400} strokeWidth={1.8} />
              <input
                value={location}
                onChange={e => setLocation(e.target.value)}
                onFocus={() => setSearchFocused(true)}
                onBlur={() => setSearchFocused(false)}
                placeholder="Your area, e.g. Westlands, Mtwapa..."
                style={{ flex: 1, border: "none", outline: "none", fontSize: 14, fontFamily: T.sans, color: T.n900, background: "transparent" }}
              />
            </div>
            <button onClick={goToSearch} style={{
              display: "inline-flex", alignItems: "center", gap: 7,
              padding: "12px 22px", background: T.g500, color: T.white,
              border: "none", borderRadius: 10, fontSize: 14, fontWeight: 600,
              cursor: "pointer", fontFamily: T.sans, whiteSpace: "nowrap",
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              <Icon name="Search" size={15} color={T.white} strokeWidth={2} />
              Find Pros
            </button>
          </div>
        </div>
      </div>

      {/* ══ TRUST STRIP ══ */}
      <div style={{ borderBottom: `1px solid ${T.n100}`, padding: "0 20px" }}>
        <div style={{ maxWidth: 720, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))" }}>
          {[
            { icon: "BadgeCheck", label: "90+ verified technicians" },
            { icon: "Star",       label: "4.6 average rating across bookings" },
            { icon: "Clock",      label: "Most devices diagnosed same day" },
          ].map(({ icon, label }, i) => (
            <div key={i} style={{ padding: "20px", display: "flex", alignItems: "center", gap: 11, borderRight: i < 2 ? `1px solid ${T.n100}` : "none" }}>
              <Icon name={icon} size={17} color={T.g500} strokeWidth={1.6} />
              <span style={{ fontSize: 13, color: T.n600, lineHeight: 1.4 }}>{label}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ maxWidth: 720, margin: "0 auto", padding: "0 20px" }}>

        {/* ══ SUB-SERVICES ══ */}
        <div style={{ paddingTop: "clamp(48px,7vw,72px)", marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>What's included</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Every device, <em style={{ fontStyle: "italic", color: T.g600 }}>someone who can fix it</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 24px", lineHeight: 1.65 }}>
            From a cracked phone screen to a fridge that stopped cooling. Prices reflect what Pros on the platform are currently charging.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(190px, 1fr))", gap: 12 }}>
            {SUBSERVICES.map((s, i) => <SubServiceCard key={i} {...s} />)}
          </div>
        </div>

        {/* ══ HOW IT WORKS ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>How it works</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Diagnosed honestly, <em style={{ fontStyle: "italic", color: T.g600 }}>fixed properly</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 28px", lineHeight: 1.65 }}>
            No guesswork, no surprise charges. Just a clear quote before any work begins.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 14 }}>
            {HOW_IT_WORKS.map((step, i) => (
              <div key={i} style={{ padding: "22px", borderRadius: 14, border: `1px solid ${T.n150}`, background: T.n50, display: "flex", gap: 16, alignItems: "flex-start" }}>
                <div style={{
                  width: 38, height: 38, borderRadius: 10, flexShrink: 0,
                  background: T.white, border: `1px solid ${T.n150}`,
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                  <Icon name={step.icon} size={17} color={T.g500} strokeWidth={1.6} />
                </div>
                <div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: T.g500, letterSpacing: "0.08em", marginBottom: 4 }}>STEP {step.num}</div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: T.n900, marginBottom: 6 }}>{step.title}</div>
                  <p style={{ fontSize: 13, color: T.n600, lineHeight: 1.65, margin: 0 }}>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 24, textAlign: "center" }}>
            <button onClick={goToSearch} style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              background: T.g500, color: T.white, border: "none",
              padding: "13px 28px", borderRadius: 11, fontSize: 14, fontWeight: 600,
              cursor: "pointer", fontFamily: T.sans,
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              Browse technicians near you
              <Icon name="ArrowRight" size={15} color={T.white} strokeWidth={2} />
            </button>
          </div>
        </div>

        {/* ══ WHY JIRANIAPP ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Why book through JiraniApp</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 24px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Trust, built into <em style={{ fontStyle: "italic", color: T.g600 }}>every booking</em>
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 14 }}>
            {WHY_POINTS.map((item, i) => (
              <div key={i} style={{ padding: "22px", borderRadius: 14, border: `1px solid ${T.n150}`, display: "flex", flexDirection: "column", gap: 12 }}>
                <div style={{ width: 38, height: 38, borderRadius: 10, background: T.g50, border: `1px solid ${T.g100}`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Icon name={item.icon} size={17} color={T.g500} strokeWidth={1.6} />
                </div>
                <div style={{ fontSize: 14, fontWeight: 600, color: T.n900 }}>{item.title}</div>
                <p style={{ fontSize: 13, color: T.n600, lineHeight: 1.7, margin: 0 }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* ══ TESTIMONIALS ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>From clients</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 24px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            What people are <em style={{ fontStyle: "italic", color: T.g600 }}>saying</em>
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 14 }}>
            {TESTIMONIALS.map((t, i) => <TestimonialCard key={i} {...t} />)}
          </div>
        </div>

        {/* ══ FAQ ══ */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Common questions</p>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4.5vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 4px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Before you <em style={{ fontStyle: "italic", color: T.g600 }}>book</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 8px", lineHeight: 1.65 }}>
            Everything clients usually ask about device repair bookings.
          </p>
          <div>
            {FAQS.map((item, i) => <FaqItem key={i} {...item} />)}
          </div>
        </div>

        {/* ══ FOOTER CTA ══ */}
        <div style={{ padding: "clamp(36px,5vw,56px)", borderRadius: 20, border: `1px solid ${T.n150}`, textAlign: "center", background: T.n50 }}>
          <div style={{ width: 52, height: 52, borderRadius: 14, background: T.g50, border: `1.5px solid ${T.g200}`, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
            <Icon name="Tv" size={22} color={T.g500} strokeWidth={1.6} />
          </div>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(28px,4.5vw,40px)", fontWeight: 400, color: T.n900, margin: "0 0 12px", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Something stopped <em style={{ fontStyle: "italic", color: T.g600 }}>working?</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 auto 32px", lineHeight: 1.75, maxWidth: 400 }}>
            Compare verified technicians near you and get an honest diagnosis.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={goToSearch} style={{
              padding: "14px 32px", background: T.g500, color: T.white,
              border: "none", borderRadius: 11, fontSize: 15, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
              display: "inline-flex", alignItems: "center", gap: 8,
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              Find a technician
              <Icon name="ArrowRight" size={15} color={T.white} strokeWidth={2} />
            </button>
            <button onClick={() => navigate("/how-it-works")} style={{
              padding: "14px 28px", background: "transparent", color: T.n700,
              border: `1.5px solid ${T.n200}`, borderRadius: 11, fontSize: 15, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
            }}
              onMouseEnter={e => e.currentTarget.style.borderColor = T.n400}
              onMouseLeave={e => e.currentTarget.style.borderColor = T.n200}>
              Learn how JiraniApp works
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}